module.exports = __webpack_public_path__ + "img/chart-mixed.b102afe9.svg";